<template>
  <div class="Product">
    <div class="content" :style="{backgroundImage:`url(${ImageUrl})`}">
      <!-- <img src="../assets/product-header.png" class="img-fluid" alt="Responsive image"> -->
      <div class="content-detail">
        <h1 data-delighter class="left">印点点自助打印系统</h1>
        <p data-delighter class="right ">印点点自助打印系统针对不同用户群，分为图文快印（QQ/微信自助打印）、共享打印（手机自助打印、远程打印）、企业办公（企业微信扫码打印）三类。用户通过印点点云打印平台实现高效、低成本的一站式自助打印服务。</p>
      </div>
    </div>
    <div class="tab-group">
      <div class="container">
        <ul class="row nav nav-tabs" id="myTab">
          <li class="col-sm text-center tab-padding activeTab" data-id="weChat">
            <img src="../assets/product1.png" class="icon" />
            <a href="#" data-toggle="tab" class="link-text">企业办公</a>
          </li>
          <li class="col-sm text-center tab-padding" data-id="share">
            <img src="../assets/product2.png" class="icon" />
            <a href="#" data-toggle="tab" class="link-text">共享打印</a>
          </li>
          <li class="col-sm text-center tab-padding" data-id="selfHelp">
            <img src="../assets/product3.png" class="icon" />
            <a href="#" data-toggle="tab" class="link-text">图文快印</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content" id="myTabContent">
      <div class="container tab-pane fade in active" id="weChat">
        <div class="row content-title">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h1>企业办公</h1>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck">
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product7.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">部门分类结算</h5>
                  <p class="card-text">按部门、个人分类计算印量印费</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product8.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">在线设备租赁</h5>
                  <p class="card-text">支持加机、移机、换机等业务受理</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product9.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">文印安全管理</h5>
                  <p class="card-text">印务行为审计与全文检索（选配）</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product10.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">设备自动报修</h5>
                  <p class="card-text">主动巡防、自动报障、自动叫修</p>
                </div>
              </div>
            </div>
            <router-link to="/OfficeSolution">
              <button type="button" class="btn btn-primary margin" data-toggle="button" aria-pressed="false" autocomplete="off">了解详情</button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container tab-pane fade" id="share">
        <div class="row content-title">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h1>共享打印</h1>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck">
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product4.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">先分机，后分成</h5>
                  <p class="card-text">联合运营，成单无忧</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product5.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">多场景自助打印</h5>
                  <p class="card-text">公共场所随时印</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product6.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">零投资，低成本</h5>
                  <p class="card-text">无需投资，免人力投入</p>
                </div>
              </div>
            </div>
            <router-link to="/ShareSolution">
              <button type="button" class="btn btn-primary margin" data-toggle="button" aria-pressed="false" autocomplete="off">了解详情</button>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container tab-pane fade" id="selfHelp">
        <div class="row content-title">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h1>图文快印</h1>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-deck">
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product11.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title"></h5>
                  <p class="card-text">自助打印软件，提高客主办事效率</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product12.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">随时随地取件</h5>
                  <p class="card-text">手机/PC随时上传文件，任意设备取件</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product13.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">自动结算费用</h5>
                  <p class="card-text">扫码支付打印，线上付免跑单</p>
                </div>
              </div>
              <div class="card card-kind">
                <img class="card-img-top product-img" src="../assets/product14.png" alt="Card image cap">
                <div class="card-body">
                  <h5 class="card-title">全天候24小时</h5>
                  <p class="card-text">一键上传，免U盘随时印</p>
                </div>
              </div>
            </div>
            <router-link to="/PrintSolution">
              <button type="button" class="btn btn-primary margin" data-toggle="button" aria-pressed="false" autocomplete="off">了解详情</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data(){
    return{
      ImageUrl:require('../assets/product-header.png')
    }
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    $(".tab-padding").bind("click", function() {
      $(this)
        .addClass("activeTab")
        .siblings()
        .removeClass("activeTab");

      let id = $(this).attr("data-id");
      $(`#${id}`)
        .addClass("in active")
        .siblings()
        .removeClass("in active");
    });
  }
};
</script>

<style lang="less" scoped>
/* Chrome, Safari, Opera */
.content {
  width: 100%;
  position: relative;
  background: no-repeat center center;
  background-size: cover;
  padding-top: 61px;
  height: 540px;
  overflow: hidden;
}

.content-detail {
  width: 60%;
  text-align: center;
  margin-top: 5%;

  // position: absolute;
  // top: 30%;
  // left: 8%;
  h1 {
    font-size: 3.2rem;
    line-height: 2rem;
    color: #fff;
    padding-left: 10%;
    text-align: left;
  }

  p {
    text-align: left;
    padding-left: 10%;
    font-size: 1.25rem;
    line-height: 2rem;
    color: #fff;
    margin-top: 30px;
    transition: all 2s ease-out;
  }

  .left {
    line-height: 1.5em;
  }

  .right {

  }
}

.tab-group {
  width: 50%;
  margin: 0 auto;
  background-color: #fff;
  box-shadow: 0px 5px 30px 0 #d6d7d7;
  border-radius: 2px;
}

.tab-padding {
  padding: 24px 0;

  .link-text {
    color: #18182a;
  }
}

.tab-padding:hover {
  .link-text {
    color: #007bff;
    text-decoration: none;
    transition: all 0.45s;
  }

  .link-text.active {
    text-decoration: none !important;
  }
}

.activeTab {
  border-bottom: 2px solid rgba(58, 107, 247, 0.8);
}

.active {
  opacity: 1 !important;
}

.icon {
  width: 56px;
  height: 48px;
  margin-right: 10px;
}

.content-title {
  text-align: center;
  padding: 60px 0 70px;

  h1 {
    color: #18182a;
    font-weight: normal;
    font-stretch: normal;
    font-size: 40px;
  }
}

.card-kind {
  padding: 20px 0;
  border: 0 !important;
}

.card-kind:hover {
  img {
    transform: rotate(360deg);
    transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);
  }

  h5 {
    color: #30bbfc;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

.product-img {
  width: 130px;
  height: 120px;
  margin: 40px auto;
}

.margin {
  margin-top: 100px;
}

.btn {
  transition: all 0.35s linear;
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue